'use client';
import { alpha, createTheme, ThemeOptions } from '@mui/material/styles';
import responsiveBaseTheme from '@/styles/brands/base';
import deepmerge from '@mui/utils/deepmerge';

const ob = createTheme(
	deepmerge(responsiveBaseTheme, {
		palette: {
			primary: {
				main: 'rgba(1, 90, 156, 1)', //#015A9C
			},
			secondary: {
				main: 'rgba(244, 116, 33, 1)', //#F47421
			},
			accent: {
				main: 'rgba(230, 239, 245, 1)', //#E6EFF5
			},
			lightBackground: {
				main: 'rgba(244, 248, 250, 1)', // #F4F8FA
			},
		},
		components: {
			MuiButton: {
				styleOverrides: {
					outlined: ({ theme }) => ({
						'&:hover': {
							backgroundColor: theme.palette.accent.main,
						},
						'&:focus': {
							backgroundColor: alpha(theme.palette.primary.main, 0.12),
						},
					}),
				},
			},
		},
	} as ThemeOptions),
);

export default ob;
